import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ScheduleAutomationFields } from '@/components/forms/ScheduleAutomationFields'
import { Typography } from '@/components/ui/typography'
import { cn } from '@/lib/utils'
import { PRICE_ADJUSTMENT_WHEN_TYPE_SCHEDULED } from '@/lib/services/price-adjustments/priceAdjustments.schema'
import { CalendarClock } from 'lucide-react'
import {
  priorityOptions,
  showPageCardClass,
  showPageIconShellClass,
  showPageScheduleIconClass,
} from './constants'
import { PriceAdjustmentFieldInfo, PriceAdjustmentPriorityLabelInfo } from './FieldInfo'

export function PriceAdjustmentScheduleSection({ controller }) {
  const {
    clearFixedEndDate,
    form,
    getRadioButtonGroupProps,
    handleFixedEndDateChange,
    handleScheduleFieldChange,
    handleStartHolidayChange,
    id,
    initialData,
    scheduleMaxDate,
    scheduleMinDate,
    scheduleSectionId,
    showPageTreatment,
    switchToFixedDateSchedule,
    switchToHolidaySchedule,
  } = controller
  return (
    <form.Subscribe selector={(state) => state.values.when_type}>
      {(whenType) =>
        whenType === PRICE_ADJUSTMENT_WHEN_TYPE_SCHEDULED ? (
          <Card
            id={scheduleSectionId}
            accent={showPageTreatment ? 'amethyst' : 'none'}
            className={showPageTreatment ? cn('scroll-mt-24', showPageCardClass) : undefined}
          >
            <CardHeader className={showPageTreatment ? 'px-5 pt-5 pb-3 sm:px-6 sm:pt-6' : ''}>
              <CardTitle className="inline-flex items-center gap-2">
                {showPageTreatment ? (
                  <span className={cn(showPageIconShellClass, showPageScheduleIconClass)}>
                    <CalendarClock className="size-5" />
                  </span>
                ) : (
                  <CalendarClock className="h-4 w-4" />
                )}
                <Typography variant="h4">Schedule</Typography>
              </CardTitle>
            </CardHeader>
            <CardContent className={cn('grid gap-y-6', showPageTreatment && 'px-5 pb-6 sm:px-6')}>
              <form.AppField name="schedule">
                {() => <PriceAdjustmentFieldInfo className="block" />}
              </form.AppField>

              <ScheduleAutomationFields
                clearFixedEndDate={clearFixedEndDate}
                form={form}
                handleFixedEndDateChange={handleFixedEndDateChange}
                handleScheduleFieldChange={handleScheduleFieldChange}
                handleStartHolidayChange={handleStartHolidayChange}
                id={id}
                initialData={initialData}
                scheduleMaxDate={scheduleMaxDate}
                scheduleMinDate={scheduleMinDate}
                scheduleTypeLabel="Choose a holiday-based schedule or a specific date range."
                scheduleTypeWrapperClassName={cn(
                  showPageTreatment && 'border-b border-border/20 pb-5 dark:border-white/10'
                )}
                switchToFixedDateSchedule={switchToFixedDateSchedule}
                switchToHolidaySchedule={switchToHolidaySchedule}
                fixedEndHelpText="If no end date is set, this pricing will remain active indefinitely."
                renderExtraFields={() => (
                  <form.AppField name="priority">
                    {(field) => (
                      <field.RadioButtonGroup
                        id={`${id}-priority`}
                        label="Priority"
                        labelEnd={<PriceAdjustmentPriorityLabelInfo />}
                        className={showPageTreatment ? 'w-fit max-w-full' : ''}
                        options={priorityOptions}
                        size="sm"
                        {...getRadioButtonGroupProps({
                          container: showPageTreatment ? 'w-fit max-w-full' : 'w-full sm:w-auto',
                          button: showPageTreatment
                            ? 'justify-center sm:min-w-24'
                            : 'flex-1 sm:flex-none',
                        })}
                      />
                    )}
                  </form.AppField>
                )}
              />
            </CardContent>
          </Card>
        ) : null
      }
    </form.Subscribe>
  )
}
